export enum BorderStyle {
    none = 0,
    card = 1,
    inset = 2,
    border = 3
}
